import pageNotFoundImage from '../../../assets/images/404.svg';
import EmptyView from '..';

const PageNotFound = () => {
  return <EmptyView imgSrc={pageNotFoundImage} backButton />;
};

export default PageNotFound;
